var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _vm.app != "ep"
            ? _c(
                "v-dialog",
                {
                  attrs: { persistent: "", scrollable: "", width: "60%" },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "tnccard" },
                    [
                      _c("v-card-title", { staticClass: "tnctitle" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("div", {
                            staticClass: "logo logocolor",
                            attrs: {
                              src: "../assets/images/logo_4iqBlack.svg",
                              title: "Logo",
                              alt: "Constella Logo",
                              width: "150"
                            }
                          }),
                          _vm._v(" "),
                          _c("h2", [_vm._v("Constella Acceptable Use Policy")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "tnctext" },
                        [
                          _c("p", {
                            domProps: { innerHTML: _vm._s(_vm.templateData) }
                          }),
                          _vm._v(" "),
                          !_vm.fromheader
                            ? _c("v-checkbox", {
                                staticClass: "tnccheckbox",
                                attrs: {
                                  color: "#5D1D99",
                                  "off-icon": "check_box_outline_blank",
                                  "on-icon": "check_box",
                                  label: "Accept Terms of Use"
                                },
                                model: {
                                  value: _vm.tncval,
                                  callback: function($$v) {
                                    _vm.tncval = $$v
                                  },
                                  expression: "tncval"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "tncactions" },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          !_vm.fromheader
                            ? [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "reject-btn",
                                    attrs: { color: "grey", flat: "" },
                                    on: { click: _vm.closeDialog }
                                  },
                                  [_vm._v("Reject")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "accept-btn",
                                    class: !_vm.tncval ? "btn-disabled" : "",
                                    attrs: {
                                      dark: _vm.tncval,
                                      color: "#5D1D99"
                                    },
                                    on: { click: _vm.accepttnc }
                                  },
                                  [_vm._v("Accept")]
                                )
                              ]
                            : _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "blue darken-1",
                                    flat: "flat"
                                  },
                                  on: { click: _vm.closeDialog }
                                },
                                [_vm._v("Close")]
                              )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.app == "ep"
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    persistent: "",
                    scrollable: "",
                    width: "40%",
                    "background-color": "white"
                  },
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c("div", { staticClass: "appTnc__main-container" }, [
                    _c("div", { staticClass: "appTnc__text-container" }, [
                      _c("div", { staticClass: "mainTitle_container" }, [
                        _c("p", [_vm._v("EVALUATION AGREEMENT")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text_container",
                          attrs: { id: "tenantTncText" }
                        },
                        [
                          _c("div", {
                            staticClass: "subText__container",
                            domProps: { innerHTML: _vm._s(_vm.templateData) }
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            attrs: {
                              label:
                                "I agree to the terms of the Constella Evaluation Agreement"
                            },
                            model: {
                              value: _vm.agreeTncCheckBox,
                              callback: function($$v) {
                                _vm.agreeTncCheckBox = $$v
                              },
                              expression: "agreeTncCheckBox"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "footer_container" }, [
                        _c(
                          "p",
                          {
                            staticClass: "download",
                            on: {
                              click: function($event) {
                                return _vm.downloadFile()
                              }
                            }
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("icon-download_file")
                            ]),
                            _vm._v("Download")
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "actionButtons" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "cancel",
                                attrs: { depressed: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.closeDialog()
                                  }
                                }
                              },
                              [_vm._v("Cancel")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "agree",
                                class: _vm.agreeTncCheckBox
                                  ? "enable"
                                  : "disable",
                                attrs: { depressed: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.accepttnc("ep")
                                  }
                                }
                              },
                              [_vm._v("I AGREE")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }